import { attributePropertyTypes, Property, PropertyType, DefaultType } from 'api/clients/PropertyClient'
import { type Group, type Operand, type Condition } from './Filter'
import { Operator, Join } from './constants'

const defaultOperatorForPropertyType = (property: Property) => {
  switch (property.type) {
    case PropertyType.Text:
      return Operator.Contains
    case PropertyType.Number:
      return Operator.Eq
    case PropertyType.Checkbox:
      return Operator.Empty
    default:
      return Operator.Eq
  }
}

export const defaultValueForProperty = (property: Property) => {
  switch (property.type) {
    case PropertyType.Text:
    case PropertyType.SingleSelect:
    case PropertyType.Checkbox:
    case PropertyType.Title:
      return ''
    case PropertyType.Person:
    case PropertyType.MultiSelect:
    case PropertyType.Date:
      return []
    default:
      return ''
  }
}

export const enum DefaultPropertyAttributes {
  Owner = 'owner_id',
  Updated = 'last_edited_at',
  Created = 'created_at',
  Posts = 'posts',
}

export const attributeForDefaultProperty = (property: Property) => {
  switch (property.default_type) {
    case DefaultType.Owner:
      return DefaultPropertyAttributes.Owner
    case DefaultType.Updated:
      return DefaultPropertyAttributes.Updated
    case DefaultType.Created:
      return DefaultPropertyAttributes.Created
  }
}

const operandForProperty = (property: Property): Operand => {
  if (attributePropertyTypes.includes(property.type)) {
    return { kind: 'attribute', attribute: property.type }
  }

  if (
    property.is_default &&
    property.default_type &&
    ![DefaultType.Status, DefaultType.Assignee, DefaultType.Posts, DefaultType.PostStatus].includes(property.default_type)
  ) {
    return { kind: 'attribute', attribute: attributeForDefaultProperty(property) }
  }
  return { kind: 'property', property_id: property.id }
}

export const defaultFilterForProperty = (property: Property): Group => {
  return {
    glue: Join.And,
    conditions: [
      {
        operand: operandForProperty(property),
        operator: defaultOperatorForPropertyType(property),
        value: defaultValueForProperty(property),
      },
    ],
  }
}

const defaultOperatorForProperty = (property: Property) => {
  switch (property.type) {
    case PropertyType.Text:
      return Operator.Eq
    case PropertyType.SingleSelect:
    case PropertyType.MultiSelect:
    case PropertyType.Date:
    case PropertyType.Document:
    case PropertyType.Person:
    case PropertyType.Checkbox:
    case PropertyType.Number:
    case PropertyType.Link:
      return Operator.Eq
  }

  return Operator.Eq
}

export const defaultConditionForProperty = (property: Property): Condition => {
  return {
    operand: operandForProperty(property),
    operator: defaultOperatorForProperty(property),
    value: defaultValueForProperty(property),
  }
}
